var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content section-loading"},[_c('div',[_vm._v("We weren't able to load the page.")]),_c('span',{staticClass:"button active",on:{"click":function($event){return _vm.reloadPage()}}},[_vm._v("Retry")])])
}
var staticRenderFns = []

export { render, staticRenderFns }